<!--
 Created by Xuz on 2019/07/16.
 xuz[at]live[dot]cn
 流程编辑器 - 新建流程
-->
<template>
    <div title="新建流程"
             :width="900"
             :visible="visible"
             :maskClosable="false"
             @ok="onSubmit"
             @cancel="$emit('cancel')"
             :confirmLoading="modalLoading"
             class="wf-editor"
             destroyOnClose>
        <a-alert :message="message" banner :type="messageType"/>
        <div id="WFContainer" style="width:900px;height:400px;margin-bottom:4px" tabindex="0">
        <svg id="WFDesigner" width="900px" height="400px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
                <marker preserveAspectRatio="xMidYMid meet" orient="auto" markerHeight="15" markerWidth="4"
                        markerUnits="strokeWidth" refY="5" refX="0" viewBox="0 0 10 10" id="arrow">
                    <path stroke="black" fill="black" d="M 0 0 L 10 5 L 0 10 z"/>
                </marker>
            </defs>

            <rect style="stroke:none;fill:rgb(255,255,255)" height="100%" width="100%" y="0" x="0" id="WFBACKGROUND"/>

            <g id="ToolBarContainer"/>

            <g>
                <text x="0" y="0">
                    <textPath xlink:href="#line_794a872d-8992-4372-8aba-512463add504" startOffset="50%">
                        <tspan>条件45</tspan>
                    </textPath>
                </text>
                <path d="M 116,89 L 281,131" stroke-width="1.3" marker-end="url(#arrow)" stroke="black"
                      cursor="move" id="line_794a872d-8992-4372-8aba-512463add504"></path>
            </g>
        </svg>
        </div>

        <WFObject ref="objectNode" />
        <WFStarNode ref="startNode" />
        <WFEndNode ref="endNode" />
        <WFTransNode ref="transNode" />

    </div>
</template>

<script>
import Workflow from './js/WorkFlow'
import WFObject from './WFObject'
import WFStarNode from './WFStarNode'
import WFEndNode from './WFEndNode'
import WFTransNode from './WFTransNode'

export default {
  name: 'WFAdd',
  components: {
    WFObject,
    WFStarNode,
    WFEndNode,
    WFTransNode
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modalLoading: false,
      message: '流程设计器',
      messageType: 'warning',
      wf: null,
      formData: {
        svg: null,
        activity: null,
        comment: null
      },
      modalVisible: {
        startNode: false
      }
    }
  },
  mounted: function () {
    this.initWorkFlow()
  },
  methods: {
    preWFAdd () {
      this.$nextTick(function () {
        this.initWorkFlow()
      })
    },
    onSubmit () {
    },
    initWorkFlow () {
      alert('initWorkFlow')
      this.wf = new Workflow(this, '#WFDesigner')
    },
    setMessage (message) {
      if (message === '') {
        this.message = '流程设计器'
        this.messageType = 'warning'
      } else {
        this.message = message
        this.messageType = 'error'
      }
    },
    onKeyDown () {
      console.log('onKeyDown')
    },
    onEditObjectNode (wfNode) {
      this.$refs.objectNode.show(wfNode)
    },
    onEditStartNode (wfNode) {
      this.$refs.startNode.show(wfNode)
    },
    onEditCommonNode (wfNode) {
    },
    onEditEndNode (wfNode) {
      this.$refs.endNode.show(wfNode)
    },
    onEditTransNode (wfNode) {
      this.$refs.transNode.show(wfNode)
    }
  }
}
</script>

<style lang="less">
    .wf-editor .ant-modal-body {
        padding: 0 !important;
    }

    #WFDesigner text {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
</style>
